import React from 'react'
import { Icon, Grid, Card, Label, Popup, Dropdown } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import Labels from '../../../../common/Labels';
import PlaceholderExampleHeaderImage from '../../../../drive/PlaceHolder/PlaceHolderLoading';

class TeamNameAndMemberDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    gotToManager = async (data) => {
        await dispatch.users.updateState(data);
        const history = this.props.history
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userDetail/${this.props.match.params.teamId}/Manager/${data._id}`);
        // http://localhost:3000/app/5dfa0109431d935690fdabb4/_ws/5dfa0109431d935690fdabcc/_cm/userDetail/5e29a421deb9142eabf2fb15/Manager/5dfa0109431d935690fdabb1
    }
    render() {
        const { managerList } = this.props
        return (
            <Card className="w_100 mar_0" style={{ borderRadius: "0" }} >
                <Card.Content className="pad_0" >
                    <Grid celled='internally'>
                        <Grid.Row>
                            <Grid.Column style={{ width: "calc(100% - 290px)" }}>
                                {
                                    this.props.selectedSubOrg ? <React.Fragment>
                                        <div style={{ float: "left", margin: " 0 10px 0 0" }}>
                                            <span className="memberCountInTeam" style={{ width: "40px", height: "40px" }}>
                                                <Icon style={{ color: '#ffffff', margin: "4px 0 0 0" }} className="f_20" name="users" />
                                            </span>
                                        </div>
                                        <Labels
                                            style={{ margin: "7px 0 7px 0" }}
                                            text={<EllipsisTooltip
                                                name={this.props.selectedSubOrg && this.props.selectedSubOrg.name}
                                                line={1}
                                                position="top center"
                                                ReadMore={false}
                                                htmlView={true}
                                                className="f_16"
                                                style={{ fontWeight: "bold" }}
                                            />}
                                        />
                                    </React.Fragment> :
                                        <PlaceholderExampleHeaderImage />

                                }

                                {/* <Labels
                                    text={<EllipsisTooltip name={this.props.selectedSubOrg && this.props.selectedSubOrg.summary}
                                        line={2}
                                        position="right center"
                                        ReadMore={true}
                                        htmlView={true}
                                    />}
                                /> */}
                            </Grid.Column>

                            <Grid.Column style={{ width: "290px" }}>
                                {managerList && managerList.length && managerList.length !== 0 ?

                                    <div className="float-left">
                                        <div className="float-left" style={{ margin: "4px 0 0 0" }}>
                                            <label>{managerList.length > 1 ? ' Team Managers' : ' Team Manager'}</label>
                                            <Label size="small" >{managerList.length}</Label>
                                        </div>
                                        <div className="float-left" style={{ margin: "0 20px" }}>
                                            {managerList && managerList.filter((i, index) => (index <= 4)).map((item, i) => {
                                                return <Popup
                                                    key={i}
                                                    mouseEnterDelay={400}
                                                    inverted
                                                    className="popupStyled"
                                                    content={item.firstName + ' ' + item.lastName}
                                                    position="bottom center"
                                                    trigger={
                                                        <div
                                                            onClick={() => this.gotToManager(item)}
                                                            className="float-left cursor-pointer"
                                                            style={{ position: "absolute", margin: `0 0 0 ${i * 24}px` }}>
                                                            <ImageAvater
                                                                user={item}
                                                                className="width_30 h_30"
                                                                imageStyle="width_30 h_30"
                                                            />
                                                        </div>
                                                    }
                                                >
                                                </Popup>
                                            })}
                                            {managerList && managerList.length > 5 ?
                                                <div className="float-left" style={{ width: "20px", margin: `0 0 0 120px` }}>
                                                    <span className="memberCountInTeam">
                                                        <Dropdown
                                                            text={<span style={{ padding: "0 5px" }}> +{managerList.length - 5}</span>}

                                                            simple
                                                            direction="left"

                                                        >
                                                            <Dropdown.Menu>
                                                                {managerList && managerList.filter((i, index) => (index > 4)).map((item, i) => (
                                                                    <div
                                                                        key={i}
                                                                        style={{ pointerEvents: "all" }}
                                                                        role="option"
                                                                        aria-checked="false"
                                                                        aria-selected="true"
                                                                        className="selected item"
                                                                        onClick={() => this.gotToManager(item)}
                                                                    >
                                                                        <img src={item.profilePic} className="ui avatar image" alt={item.firstName} />
                                                                        <span className="text"
                                                                            style={{
                                                                                margin: "5px 0 0 0",
                                                                                display: "inline-flex"
                                                                            }}>{item.firstName + ' ' + item.lastName} </span>
                                                                    </div>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        {/* + {managerList.length - 5} */}
                                                    </span>
                                                </div>
                                                : null}
                                        </div>
                                    </div> :
                                    <PlaceholderExampleHeaderImage />
                                }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Card.Content>

            </Card>
        )
    }
}
export default withRouter(TeamNameAndMemberDetail);